export * from "ce/constants/ReduxActionConstants";
import {
  ReduxActionTypes as ReduxActionTypesCE,
  ReduxActionErrorTypes as ReduxActionErrorTypesCE,
} from "ce/constants/ReduxActionConstants";

export const ReduxActionTypes = {
  ...ReduxActionTypesCE,
  ONBOARDING_CREATE_APPLICATION: "ONBOARDING_CREATE_APPLICATION",
  UPDATE_CURRENT_TENANT_CONFIG: "UPDATE_CURRENT_TENANT_CONFIG",
  UPDATE_CURRENT_TENANT_CONFIG_SUCCESS: "UPDATE_CURRENT_TENANT_CONFIG_SUCCESS",
  UPDATE_TENANT_CONFIG: "UPDATE_TENANT_CONFIG",
  UPDATE_TENANT_CONFIG_SUCCESS: "UPDATE_TENANT_CONFIG_SUCCESS",
  FETCH_USERS_INIT: "FETCH_USERS_INIT",
  FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS",
  FETCH_USER_DETAIL_INIT: "FETCH_USERS_DETAIL_INIT",
  FETCH_USER_DETAIL_SUCCESS: "FETCH_USERS_DETAIL_SUCCESS",
  DELETE_USER: "DELETE_USER",
  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  UPDATE_USER_STATE: "UPDATE_USER_STATE",
  FETCH_ROLES_FOR_USER_ASSIGN_INIT: "FETCH_ROLES_FOR_USER_ASSIGN_INIT",
  FETCH_ROLES_FOR_USER_ASSIGN_SUCCESS: "FETCH_ROLES_FOR_USER_ASSIGN_SUCCESS",
  FETCH_USER_GROUPS_FOR_INVITE_INIT: "FETCH_USER_GROUPS_FOR_INVITE_INIT",
  FETCH_USER_GROUPS_FOR_INVITE_SUCCESS: "FETCH_USER_GROUPS_FOR_INVITE_SUCCESS",
  FETCH_USER_GROUPS_INIT: "FETCH_USER_GROUPS_INIT",
  FETCH_USER_GROUPS_SUCCESS: "FETCH_USER_GROUPS_SUCCESS",
  FETCH_USER_GROUP_DETAIL_INIT: "FETCH_USER_GROUP_DETAIL_INIT",
  FETCH_USER_GROUP_DETAIL_SUCCESS: "FETCH_USER_GROUP_DETAIL_SUCCESS",
  CREATE_USER_GROUP: "CREATE_USER_GROUP",
  CREATE_USER_GROUP_SUCCESS: "CREATE_USER_GROUP_SUCCESS",
  DELETE_USER_GROUP: "DELETE_USER_GROUP",
  DELETE_USER_GROUP_SUCCESS: "DELETE_USER_GROUP_SUCCESS",
  UPDATE_USER_GROUP: "UPDATE_USER_GROUP",
  UPDATE_USER_GROUP_SUCCESS: "UPDATE_USER_GROUP_SUCCESS",
  USER_GROUP_INVITE_USER: "USER_GROUP_INVITE_USER",
  USER_GROUP_INVITE_USER_SUCCESS: "USER_GROUP_INVITE_USER_SUCCESS",
  USER_GROUP_REMOVE_USER: "USER_GROUP_REMOVE_USER",
  USER_GROUP_REMOVE_USER_SUCCESS: "USER_GROUP_REMOVE_USER_SUCCESS",
  USER_UPDATE_GROUPS: "USER_UPDATE_GROUPS",
  USER_UPDATE_GROUPS_SUCCESS: "USER_UPDATE_GROUPS_SUCCESS",
  ROLES_ASSOCIATE: "ROLES_ASSOCIATE",
  ROLES_ASSOCIATE_SUCCESS: "ROLES_ASSOCIATE_SUCCESS",
  FETCH_ROLES_INIT: "FETCH_ROLES_INIT",
  FETCH_ROLES_SUCCESS: "FETCH_ROLES_SUCCESS",
  FETCH_ROLE_INIT: "FETCH_ROLE_INIT",
  FETCH_ROLE_SUCCESS: "FETCH_ROLE_SUCCESS",
  CREATE_ROLE_INIT: "CREATE_ROLE_INIT",
  CREATE_ROLE_SUCCESS: "CREATE_ROLE_SUCCESS",
  DELETE_ROLE_INIT: "DELETE_ROLE_INIT",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",
  UPDATE_ROLE_INIT: "UPDATE_ROLE_INIT",
  UPDATE_ROLE_SUCCESS: "UPDATE_ROLE_SUCCESS",
  FETCH_ROLE_CONFIG_INIT: "FETCH_ROLE_CONFIG_INIT",
  FETCH_ROLE_CONFIG_SUCCESS: "FETCH_ROLE_CONFIG_SUCCESS",
  UPDATE_ROLE_CONFIG_INIT: "UPDATE_ROLE_CONFIG_INIT",
  UPDATE_ROLE_CONFIG_SUCCESS: "UPDATE_ROLE_CONFIG_SUCCESS",
  SET_IDE_EDITOR_VIEW_MODE: "SET_IDE_EDITOR_VIEW_MODE",
  RESTORE_IDE_EDITOR_VIEW_MODE: "RESTORE_IDE_EDITOR_VIEW_MODE",
  SET_IDE_EDITOR_PAGES_ACTIVE_STATUS: "SET_IDE_EDITOR_PAGES_ACTIVE_STATUS",
  SET_IDE_JS_TABS: "SET_IDE_JS_TABS",
  SET_IDE_QUERIES_TABS: "SET_IDE_QUERIES_TABS",
  FETCH_CURRENT_USER_SYSTEM_ROLES_INIT: "FETCH_CURRENT_USER_SYSTEM_ROLES_INIT",
  FETCH_CURRENT_USER_SYSTEM_ROLES_SUCCESS:
    "FETCH_CURRENT_USER_SYSTEM_ROLES_SUCCESS",
  FETCH_ALL_SYSTEM_ROLES_INIT: "FETCH_ALL_SYSTEM_ROLES_INIT",
  FETCH_ALL_SYSTEM_ROLES_SUCCESS: "FETCH_ALL_SYSTEM_ROLES_SUCCESS",
  USER_UPDATE_SYSTEM_ROLES: "USER_UPDATE_SYSTEM_ROLES",
  USER_UPDATE_SYSTEM_ROLES_SUCCESS: "USER_UPDATE_SYSTEM_ROLES_SUCCESS",
  CREATE_SETTINGS_USER_INIT: "CREATE_SETTINGS_USER_INIT",
  CREATE_SETTINGS_USER_SUCCESS: "CREATE_SETTINGS_USER_SUCCESS",
  FETCH_DRAFT_DSL_SUCCESS: "FETCH_DRAFT_DSL_SUCCESS",
  FETCH_DRAFT_DSLS_SUCCESS: "FETCH_DRAFT_DSLS_SUCCESS",
  FETCH_PUBLISHED_DRAFT_DSL_SUCCESS: "FETCH_PUBLISHED_DRAFT_DSL_SUCCESS",
  SAVE_PAGE_DRAFT: "SAVE_PAGE_DRAFT",
  SAVE_DRAFT_SUCCESS: "SAVE_DRAFT_SUCCESS",
  RESTORE_DRAFT_SUCCESS: "RESTORE_DRAFT_SUCCESS",
  RESTORE_DRAFT: "RESTORE_DRAFT",
  DELETE_DRAFT: "DELETE_DRAFT",
  DELETE_DRAFT_SUCCESS: "DELETE_DRAFT_SUCCESS",
  GET_PAGE_DRAFT: "GET_PAGE_DRAFT",
  GET_PAGE_DRAFT_SUCCESS: "GET_PAGE_DRAFT_SUCCESS",
  FETCH_PUBLISHED_PAGE_RESOURCES_INIT: "FETCH_PUBLISHED_PAGE_RESOURCES_INIT",
  FETCH_PUBLISHED_PAGE_RESOURCES_SUCCESS: "FETCH_PUBLISHED_PAGE_RESOURCES_SUCCESS",
  RESET_WIDGETS_META: "RESET_WIDGETS_META",
};

export const ReduxActionErrorTypes = {
  ...ReduxActionErrorTypesCE,
  UPDATE_CURRENT_TENANT_CONFIG_ERROR: "UPDATE_CURRENT_TENANT_CONFIG_ERROR",
  FETCH_CURRENT_TENANT_CONFIG_ERROR: "FETCH_CURRENT_TENANT_CONFIG_ERROR",
  UPDATE_TENANT_CONFIG_ERROR: "UPDATE_TENANT_CONFIG_ERROR",
  FETCH_USERS_ERROR: "FETCH_USERS_ERROR",
  FETCH_USER_DETAIL_ERROR: "FETCH_USERS_DETAIL_ERROR",
  DELETE_USER_ERROR: "DELETE_USER_ERROR",
  FETCH_ROLES_FOR_USER_ASSIGN_ERROR: "FETCH_ROLES_FOR_USER_ASSIGN_ERROR",
  FETCH_USER_GROUPS_FOR_INVITE_ERROR: "FETCH_USER_GROUPS_FOR_INVITE_ERROR",
  FETCH_USER_GROUPS_ERROR: "FETCH_USER_GROUPS_ERROR",
  FETCH_USER_GROUP_DETAIL_ERROR: "FETCH_USER_GROUP_DETAIL_ERROR",
  CREATE_USER_GROUP_ERROR: "CREATE_USER_GROUP_ERROR",
  DELETE_USER_GROUP_ERROR: "DELETE_USER_GROUP_ERROR",
  UPDATE_USER_GROUP_ERROR: "UPDATE_USER_GROUP_ERROR",
  USER_GROUP_INVITE_USER_ERROR: "USER_GROUP_INVITE_USER_ERROR",
  USER_GROUP_REMOVE_USER_ERROR: "USER_GROUP_REMOVE_USER_ERROR",
  USER_UPDATE_GROUPS_ERROR: "USER_UPDATE_GROUPS_ERROR",
  ROLES_ASSOCIATE_ERROR: "ROLES_ASSOCIATE_ERROR",
  FETCH_ROLES_ERROR: "FETCH_ROLES_ERROR",
  FETCH_ROLE_ERROR: "FETCH_ROLE_ERROR",
  CREATE_ROLE_ERROR: "CREATE_ROLE_ERROR",
  DELETE_ROLE_ERROR: "DELETE_ROLE_ERROR",
  UPDATE_ROLE_ERROR: "UPDATE_ROLE_ERROR",
  FETCH_ROLE_CONFIG_ERROR: "FETCH_ROLE_CONFIG_ERROR",
  UPDATE_ROLE_CONFIG_ERROR: "UPDATE_ROLE_CONFIG_ERROR",
  FETCH_CURRENT_USER_SYSTEM_ROLES_ERROR:
    "FETCH_CURRENT_USER_SYSTEM_ROLES_ERROR",
  FETCH_ALL_SYSTEM_ROLES_ERROR: "FETCH_ALL_SYSTEM_ROLES_ERROR",
  USER_UPDATE_SYSTEM_ROLES_ERROR: "USER_UPDATE_SYSTEM_ROLES_ERROR",
  FETCH_PUBLISHED_PAGE_RESOURCES_ERROR: "FETCH_PUBLISHED_PAGE_RESOURCES_ERROR",
};
